module.exports = __webpack_public_path__ + "img/linkedin-icon.f5032a5f.svg";